import React, {useMemo} from "react";
import {SelectChipInput} from "~/apps/core/ui/ChipInput/SelectChipInput"
import {CargoV2} from "~/apps/packages/auto-visits/queries";
import {humanizeCargoDirection} from "~/apps/packages/auto-visits/utils";


type Value = CargoV2["direction"];

const VALUES: Value[] = [
    "Завоз", "Вывоз", "Транзит"
];


export type CargoDirectionChipInputProps = {
    value?: Value
    onChange?: (value: Value) => any
    disabled?: boolean
}


export const CargoDirectionChipInput = (props: CargoDirectionChipInputProps) => {
    const options = useMemo(() => VALUES.map(value => ({
        value: value,
        title: humanizeCargoDirection(value),
    })).concat([
        {
            title: "Все",
            value: null
        }
    ]), []);

    const title = "Направление";
    const label = useMemo(() => {
        return options.find(x => x.value == props.value)?.title || title;
    }, [options, props.value])

    return (
        <SelectChipInput {...props} title={title} label={label} options={options}/>
    )
}